<div class="action-modal" [class.action-modal--visible]="isVisible" [ngClass]="modalClass">
    <div class="action-modal__container" [ngClass]="'action-modal__container--' + size">
        <span
            *ngIf="!hideCloseButton"
            class="action-modal__close-button"
            (click)="onCloseButtonClick()"
            >&times;</span
        >
        <div class="action-modal__content">
            <img *ngIf="iconPath" class="action-modal__image" [src]="iconPath" alt="Icon" />
            <div class="action-modal__title" [innerHTML]="title"></div>
            <p class="action-modal__description" *ngIf="description" [innerHTML]="description"></p>
            <div class="action-modal__buttons">
                <button
                    *ngIf="secondaryButton"
                    class="action-modal__button action-modal__button--secondary"
                    [class.action-modal__button--disabled]="secondaryButton.disabled"
                    [disabled]="secondaryButton.disabled"
                    (click)="secondaryButton.action()"
                >
                    {{ secondaryButton.label }}
                </button>
                <button
                    *ngIf="secondaryNoButton"
                    class="action-modal__no-button"
                    [class.action-modal__button--disabled]="secondaryNoButton.disabled"
                    [disabled]="secondaryNoButton.disabled"
                    (click)="secondaryNoButton.action()"
                >
                    {{ secondaryNoButton.label }}
                </button>
                <button
                    *ngIf="primaryButton"
                    class="action-modal__button action-modal__button--primary"
                    [class.action-modal__button--disabled]="primaryButton.disabled"
                    [disabled]="primaryButton.disabled"
                    (click)="primaryButton.action()"
                >
                    {{ primaryButton.label }}
                </button>
            </div>
        </div>
    </div>
</div>
